module.exports = __webpack_public_path__ + "img/img_index_thumb_sms_intro_2.68b59066.jpg";